import React from 'react'

const PartCollection = () => {
  return (
    <div>PartCollection</div>
  )
}

export default PartCollection